import { RemixComment } from 'types/comment';
import Avatar from 'components/common/Avatar';
import CommentAuthor from './CommentAuthor';

import commentStyles from './Comment.module.css';
import styles from './RemixComment.module.css';
import Link from 'next/link';
import { getCommunityPostUrl } from 'lib/community';

type Props = {
  remix: RemixComment;
};

export default function RemixCommentGroup({ remix }: Props) {
  const owner = {
    username: remix.username,
    avatar: remix.avatar,
    ownerId: remix.ownerId,
  };

  const communityUrl = getCommunityPostUrl(remix.slug);

  return (
    <div className={commentStyles.Comment}>
      <div className={commentStyles.CommentFirstColumn}>
        <Avatar data={owner} />
      </div>
      <div className={commentStyles.CommentMainColumn}>
        <div className={styles.RemixPublished}>
          <CommentAuthor author={owner} />
          <span className={styles.PublishText}>published a remix</span>
        </div>
        <div className={styles.RemixThumbnail}>
          <Link href={communityUrl}>
            <a>
              <img
                className={styles.ThumbnailImage}
                src={remix.thumbnailUrl}
                aria-label={remix.title}
              />
            </a>
          </Link>
        </div>
      </div>
    </div>
  );
}
